function toTrimmedString(value) {
  if (value == null) return "";
  return String(value).trim();
}

export function getSessionIdValue(session) {
  return toTrimmedString(session?.sessionId || session?.session_id);
}

export function getSessionCodeValue(session) {
  return toTrimmedString(session?.sessionCode || session?.code);
}

export function getPreferredSessionIdentifier(session) {
  return getSessionIdValue(session) || getSessionCodeValue(session);
}

export function getSessionIdFromEvents(events) {
  if (!Array.isArray(events)) return "";

  for (const event of events) {
    const sessionId = getSessionIdValue(event);
    if (sessionId) return sessionId;
  }

  return "";
}
